// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { DatapointsSeriesFromJSON, DatapointsSeriesToJSON, } from './';
export function DatapointsResponseItemFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'series': !exists(json, 'series') ? undefined : json['series'].map(DatapointsSeriesFromJSON),
        'totals': !exists(json, 'totals') ? undefined : json['totals'].map(DatapointsSeriesFromJSON),
        'fields': !exists(json, 'fields') ? undefined : json['fields'],
    };
}
export function DatapointsResponseItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'series': value.series === undefined ? undefined : value.series.map(DatapointsSeriesToJSON),
        'totals': value.totals === undefined ? undefined : value.totals.map(DatapointsSeriesToJSON),
        'fields': value.fields,
    };
}
